export default "__VITE_ASSET__CbAwYUPg__"